/* NUVELA — Wishlist (localStorage) */
(function () {
  'use strict';

  var KEY = 'nv_wishlist_v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
    notify();
  }
  function notify() {
    document.dispatchEvent(new CustomEvent('nv:wishlist:change', { detail: { items: read() } }));
  }

  var W = {
    list:   function ()       { return read(); },
    has:    function (handle) { return read().indexOf(handle) !== -1; },
    add:    function (handle) {
      var a = read();
      if (a.indexOf(handle) === -1) { a.push(handle); write(a); }
    },
    remove: function (handle) {
      var a = read().filter(function (h) { return h !== handle; });
      write(a);
    },
    toggle: function (handle) {
      if (W.has(handle)) { W.remove(handle); return false; }
      W.add(handle); return true;
    },
    clear:  function () { write([]); }
  };
  window.NuvelaWishlist = W;

  function setHidden(el, hide) {
    if (!el) return;
    if (hide) { el.setAttribute('hidden', ''); el.style.display = 'none'; }
    else      { el.removeAttribute('hidden'); el.style.display = ''; }
  }

  function updateButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      var active = W.has(handle);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.classList.toggle('is-active', active);
    });
  }

  function updateBadges() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      setHidden(el, n === 0);
    });
  }

  /* Click on heart (event delegation, catches clicks even inside <a> wrappers) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    var added = W.toggle(handle);
    btn.classList.add('is-bumping');
    setTimeout(function () { btn.classList.remove('is-bumping'); }, 400);
    if (btn.dataset.toast !== 'off') {
      showToast(added ? 'Agregado a favoritos' : 'Removido de favoritos');
    }
  }, true); /* capture: runs before any descendant link handlers */

  function showToast(msg) {
    var t = document.createElement('div');
    t.className = 'nv-wl-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () {
      t.classList.remove('is-in');
      setTimeout(function () { t.remove(); }, 300);
    }, 2200);
  }

  document.addEventListener('nv:wishlist:change', function () {
    updateButtons();
    updateBadges();
  });

  /* Sync across tabs */
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) notify();
  });

  function init() {
    updateButtons();
    updateBadges();
    initFavoritosPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Render favoritos list on /pages/favoritos */
  function initFavoritosPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    renderList();
    document.addEventListener('nv:wishlist:change', renderList);

    function renderList() {
      var handles = read();
      var empty = document.querySelector('[data-wishlist-empty]');
      grid.innerHTML = '';
      if (!handles.length) {
        setHidden(empty, false);
        return;
      }
      setHidden(empty, true);
      handles.forEach(function (h) {
        fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (p) grid.appendChild(card(p));
            else   W.remove(h); /* product no longer exists, clean up */
          })
          .catch(function () {});
      });
    }

    function card(p) {
      var img = (p.featured_image || (p.images && p.images[0]) || '').replace(/^http:/, 'https:');
      var imgSrc = img ? img.replace(/(\.(?:jpe?g|png|webp|gif))(\?|$)/i, '_600x$1$2') : '';
      var price = formatMoney(p.price);
      var compare = p.compare_at_price > p.price ? formatMoney(p.compare_at_price) : '';
      var available = p.available !== false;
      var wrap = document.createElement('article');
      wrap.className = 'nv-wl__card';
      wrap.innerHTML =
        '<a class="nv-wl__media" href="/products/' + escAttr(p.handle) + '">' +
          (imgSrc ? '<img src="' + escAttr(imgSrc) + '" alt="" loading="lazy">' : '<div class="nv-wl__media-empty"></div>') +
          (available ? '' : '<span class="nv-wl__badge">Agotado</span>') +
        '</a>' +
        '<div class="nv-wl__body">' +
          '<a class="nv-wl__title" href="/products/' + escAttr(p.handle) + '">' + escHtml(p.title) + '</a>' +
          '<div class="nv-wl__price">' +
            '<span>' + price + '</span>' +
            (compare ? '<span class="nv-wl__compare">' + compare + '</span>' : '') +
          '</div>' +
          '<div class="nv-wl__actions">' +
            '<button type="button" class="nv-wl__remove" data-wishlist-toggle data-product-handle="' + escAttr(p.handle) + '" data-toast="off">Quitar</button>' +
            (available ? '<a class="nv-wl__cta" href="/products/' + escAttr(p.handle) + '">Ver producto</a>' : '') +
          '</div>' +
        '</div>';
      return wrap;
    }

    function formatMoney(cents) {
      var n = (cents / 100).toFixed(0);
      return '$' + n.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    function escHtml(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
      });
    }
    function escAttr(s) { return escHtml(s); }
  }
})();
